const dashboard = {
  en: {
    translation: {
      dashboard: "Dashboard",
      add_field_name: "Add name",
      add_field_alias: "Add alias",
      add_field_emailPublic: "Add email",
      add_field_telephonePublic: "Add telephone",
      add_field_typesOfFood: "Add types of cuisine",
      add_field_meal: "Add meal",
      add_field_menu: "Add menu",
      add_field_openings: "Add openings",
      add_field_paymentMethods: "Add method of payment",
      add_field_service: "Add service",
      add_field_slogan: "Add a short description",
      add_field_parking: "Add parking details",
      add_field_location: "Add location services",
      add_field_links: "Add social links",
      reviews: "Reviews",
      reservation: "Reservations",
      checkins: "Check-ins",
      respond_reviews: "Respond to your reviews",
      claim_another_business: "Claim another business",
      click_here_to_claim_another: "Contact us for further information",
      our_plans: "Our plans",
      click_here_to_see: "Click here to find out more",
      your_website_in_one_click: "Your website in a click",
      find_out_how: "Find out more",
      certified_business: "Certified Business",
      view_card: "View your card",
      edit: "Edit",
      complete_business_page: "Complete your business page",
      backoffice_guide: "Backoffice guide",
      days_more_checkins: "Check-in days",
      target: "Target",
      search: "Searches",
      search_explenation: "Last six months considering App and Desktop",
      semester_performance: "Check-in and reviews semester performance",
      CI_and_reviews: "Check-ins and reviews",
      legend: "Legend",
      reviews_trend: "Reviews' trend",
      visit_restaurant: "Preview business",
      checkin_stats_title: "Check-in weekly report",
      checkin_stats_text: "Days with the higher check-in rate",
      reviews_stats_title: "Reviews",
      reviews_stats_text: "Ratings of the last reviews received",
      search_stats_title: "Searches",
      search_stats_text: "Last six months considering App and Desktop",
      tooltip_logout: "Logout",
      logout_confirm: "Are you sure you want to log out?",
      basic_info: "Basic info",
      cuisine: "Cuisine",
      menu: "Menu",
      calendar: "Calendar",
      services: "Services",
      location: "Location",
      link_social: "Social networks",
      images: "Images",
      legal_info: "Legal info",
      manage_roles: "Manage roles",
      certification: "Certification",
      reservation_data: "Reservation data",
      admin: "Admin",
      manage_business: "Manage business",
      settings: "Settings",
      not_enough_data: "Not enough data yet",
      general: "General",
      checkins_stats: "Check-in",
      acquisition_stats: "Acquisition",
      foodies_stats: "Foodies",
      Statistics: "Statistics",
      logout: "Logout",
      logout_short: "L",
      edit_profile: "Edit profile",
      edit_profile_short: "EP",
      restaurant_progress_completed:
        "Great job! You've added the most important info about you, this will help your customers to get to know you better, don't forget to update them regularly!",
      reviews_weekly_analysis: "Weekly analysis of reviews",
      values_for_weekday: "Scores by day of the week"
    }
  },
  it: {
    translation: {
      dashboard: "Dashboard",
      add_field_name: "Aggiungi nome",
      add_field_alias: "Aggiungi alias",
      add_field_emailPublic: "Aggiungi email",
      add_field_telephonePublic: "Aggiungi numero di telefono",
      add_field_typesOfFood: "Aggiungi tipi di cucina",
      add_field_meal: "Aggiungi pasto",
      add_field_menu: "Aggiungi menu",
      add_field_openings: "Aggiungi orari",
      add_field_paymentMethods: "Aggiungi metodi di pagamento",
      add_field_service: "Aggiungi servizi",
      add_field_slogan: "Aggiungi una breve descrizione",
      add_field_parking: "Aggiungi dettagli del parcheggio",
      add_field_location: "Aggiungi servizi della location",
      add_field_links: "Aggiungi links social",
      reviews: "Recensioni",
      reservation: "Prenotazioni",
      checkins: "Check-in",
      respond_reviews: "Scopri di più e rispondi",
      claim_another_business: "Rivendica un'altra attività",
      click_here_to_claim_another: "Contattaci per ulteriori informazioni",
      our_plans: "I nostri piani",
      click_here_to_see: "Clicca qui per visualiizarli",
      your_website_in_one_click: "Il tuo sito in un click",
      find_out_how: "Scopri come",
      certified_business: "Struttura Certificata",
      view_card: "Visualizza scheda",
      edit: "Modifica",
      complete_business_page: "Completa la pagina della tua attività",
      backoffice_guide: "Guida all'area riservata",
      days_more_checkins: "Giorni in cui ricevi più check-in",
      target: "Target",
      search: "Ricerche",
      search_explenation: "Ultimi 6 mesi tra App e Desktop",
      semester_performance: "Andamento semestrale di check-in e recensioni",
      CI_and_reviews: "Check-in e recensioni",
      legend: "Legenda",
      reviews_trend: "Andamento recensioni",
      visit_restaurant: "Anteprima struttura",
      checkin_stats_title: "Analisi settimanale dei check-in",
      checkin_stats_text: "Giorni della settimana in cui ricevi più check-in",
      reviews_stats_title: "Recensioni",
      reviews_stats_text: "Valutazioni delle ultime recensioni ricevute",
      search_stats_title: "Ricerche",
      search_stats_text: "Ultimi sei mesi tra App e Desktop",
      tooltip_logout: "Esci",
      logout_confirm: "Sei sicuro di voler effettuare il logout?",
      basic_info: "Info di base",
      menu: "Menu",
      cuisine: "Cucina",
      calendar: "Calendario",
      services: "Servizi",
      location: "Location",
      link_social: "Link social",
      images: "Immagini",
      legal_info: "Dati anagrafici / societari",
      manage_roles: "Gestione ruoli",
      certification: "Certificazione",
      reservation_data: "Dati prenotazione",
      admin: "Admin",
      manage_business: "Gestione struttura",
      settings: "Impostazioni",
      not_enough_data: "Non ci sono abbastanza dati",
      general: "Generale",
      checkins_stats: "Check-in",
      acquisition_stats: "Acquisizione",
      foodies_stats: "Foodies",
      Statistics: "Statistiche",
      logout: "Esci",
      logout_short: "E",
      edit_profile: "Modifica profilo",
      edit_profile_short: "MP",
      restaurant_progress_completed:
        "Ottimo lavoro! Hai inserito le informazioni principali che permetteranno ai tuoi clienti di conoscerti meglio, non dimenticare di aggiornarle regolarmente!",
      reviews_weekly_analysis: "Analisi settimanale delle recensioni",
      values_for_weekday: "Punteggi per giorno della settimana"
    }
  }
};

export default dashboard;
